<template>
    <ValidationObserver tag="b-row" class="contenido" ref="observer">
        <FormInput class="col-12 col-md-6" label="Concepto" infoText="(Este texto irá incluido en la entrada, máximo 15 carácteres)" name="concepto" id="concepto" v-model="datos_compradores.concepto" />
        <FormInput class="col-12 col-md-6" label="CP/ZIP CODE" minlength="5" maxlength="10" name="cp" id="cp" v-model="datos_compradores.cp" />
        <template v-if="teatro.solicitar_datos_comprador_taquilla">
            <FormInput class="col-12 col-md-6" label="Nombre" name="nombre" id="nombre" v-model="datos_compradores.nombre_comprador" rules="required" />
            <FormInput class="col-12 col-md-6" label="Apellidos" name="apellidos" id="apellidos" v-model="datos_compradores.apellidos_comprador" rules="required" />
            <FormInput class="col-12 col-md-6" label="DNI" name="dni" id="dni" v-model="datos_compradores.dni_comprador" rules="required" />
            <FormInput class="col-12 col-md-6" label="Teléfono" maxlength="9" name="telefono" id="telefono" type="number" v-model="datos_compradores.telefono_comprador" rules="required" />
        </template>
        
        <b-col cols="12" class="mb-2">
            <b-row v-for="(evento, index) in entradas" :key="index">
                <b-col cols="12">
                    <h4>{{ evento.evento }}</h4>
                    <h5>{{ evento.fecha }}</h5>
                </b-col>
                <b-col cols="12" md="6" v-for="(item, index) in evento.items" :key="index">
                    <DatosEntradasComponent
                        :entrada="item"
                        :evento="evento" 
                        :generos="generos" 
                        :index="index"
                    />
                </b-col>
                <b-col cols="12" class="mb-3" v-if="!evento.tiene_recinto">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" v-model="datos_compradores.visible" id="otros">
                        <label class="custom-control-label" for="otros">Entradas otros</label>
                    </div>
                </b-col>
            </b-row>
        </b-col>
        <b-col cols="12" class="mb-3">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" v-model="enviar_email" id="enviar_email">
                <label class="custom-control-label" for="enviar_email">Enviar por email</label>
            </div>
        </b-col>
        <b-col cols="12" class="mb-3" v-if="enviar_email">
            <FormInput label="Email" name="email" id="email" rules="required|email" v-model="datos_compradores.email" />
        </b-col>
        <b-col cols="12">
            <div class="form-group">
                <label for="metodo_pago">Método de pago / Tipo de Impresión</label>
                <ValidationProvider name="metodo_pago" rules="required" v-slot="{ errors }">
                    <select v-if="metodos_pago" v-model="datos_compradores.metodo_pago" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="metodo_pago">
                        <template v-for="(metodo, index) in metodos_pago">
                            <option :key="index" :value="metodo">{{ metodo.nombre }}</option>
                        </template>
                    </select>
                </ValidationProvider>
            </div>
        </b-col>
        <b-col cols="12">
            <DatosLegales :datos="datos_compradores"></DatosLegales>
        </b-col>
        <b-col cols="12">
            <b-btn class="btn btn-block" @click="terminar">CONTINUAR COMPRA</b-btn>
        </b-col>
    </ValidationObserver>
</template>

<script>
import Generos from "@/mixins/Generos";
import DatosEntradasComponent from './DatosEntradasComponent.vue';
import DatosLegales from '@/components/backend/stepper/components/DatosLegales';

export default {
    mixins: [Generos],
    props: {
        entradas: {
            type: Array,
            required: true
        },
        datos_compradores: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            select_all: false,
            reloadComponent: 1,
            isValid: true,
            enviar_email: false
        }
    },
    methods: {
        async terminar() {
            const isValid = await this.$refs.observer.validate();

            if (isValid) {
                this.continuar();
            }
        },
        continuar() {
            this.$emit('continuar', this.datos_compradores, this.datos_entradas)
        }
    },
    computed: {
        user() {
            return this.$store.getters.getUser;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        },
        metodos_pago() {
            let metodos_de_pago = this.teatro.metodos_pago_eventos.slice().filter(metodo_pago => metodo_pago.show_taquilla);
            const algunDatafono = this.entradas.some(evento => evento.datafono_propio);

            if (this.user.datafonos && this.user.datafonos.length) {
                const mismaCompania = this.entradas.every((item, _, arr) => item.nif === arr[0].nif);
                const todosDatafono = this.entradas.every(evento => evento.datafono_propio);

                const shouldFilterDatafono = (!mismaCompania && (algunDatafono || todosDatafono)) ||
                    (mismaCompania && todosDatafono && !this.user.datafonos.some(datafono => datafono.nif === this.entradas[0].nif));

                if (shouldFilterDatafono) {
                    metodos_de_pago = metodos_de_pago.filter(metodo_pago => metodo_pago.id !== 3);
                    this.$store.dispatch('setPuedeUsarDatafono', false);
                } else {
                    this.$store.dispatch('setPuedeUsarDatafono', true);
                }
            } else {
                if (algunDatafono) {
                    metodos_de_pago = metodos_de_pago.filter(metodo_pago => metodo_pago.id !== 3);
                }
            }

            return metodos_de_pago;
        },
        permisos() {
            return this.$store.getters.getPermisos;
        },
        datos_entradas() {
            let datos = [];

            this.entradas.forEach(evento => {
                evento.items.forEach(item => {
                    let datosEntrada = {
                        'id': item.id,
                        'datos_entrada': {
                            'entrada': item.entrada
                        }
                    };

                    if (evento.solicitar_datos) {
                        datosEntrada['datos_entrada']['nombre'] = item.nombre;
                        datosEntrada['datos_entrada']['apellidos'] = item.apellidos;
                        datosEntrada['datos_entrada']['dni'] = item.dni;
                    }

                    if (this.teatro.solicitar_genero_taquilla && item.genero_id) {
                        datosEntrada['datos_entrada']['genero_id'] = item.genero_id;
                    }

                    if (this.permisos['venta.descuento'] && item.descuento) {
                        datosEntrada['datos_entrada']['descuento'] = item.descuento;
                    }

                    datos.push(datosEntrada);
                });
            });

            return datos;
        }
    },
    created() {
        this.getGeneros();
    },
    components: {
        DatosEntradasComponent, DatosLegales
    }
}
</script>

<style scoped>
.contenido {
    background-color: #EDEDED;
    padding: 20px 40px;
    margin-bottom: 50px;
}

@media (max-width: 768px) {
    .contenido {
        padding: 10px
    }
}
</style>